"use client";

import { Button, HStack, Text, VStack } from "@chakra-ui/react";
import {
  PROFILE_SHAPING_EMPTY_STATES,
  PROFILE_SHAPING_LABELS,
} from "@/features/profile-shaping";
import GenericEmptyComponent from "@/shared/ui/GenericEmptyComponent";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import { useUserChoices } from "@/state/globalStore";

export default function BacklogEmptyState() {
  const { setInterimState } = useUserChoices();

  return (
    <VStack
      align="start"
      gap="3"
      py={{ base: "4", md: "6" }}
      maxW="xl"
      mx="auto"
    >
      <GenericEmptyComponent
        {...PROFILE_SHAPING_EMPTY_STATES.backlogSource}
        icon="origin_source"
        variant="inline"
      />

      <Text
        fontSize="sm"
        color="moveon.text.muted"
        lineHeight="tall"
        px={{ base: "2", md: "0" }}
      >
        Backlog keeps source material available as evidence and organization.
        Use Shape from source when you want material to become suggestions.
      </Text>

      <HStack
        gap="2"
        justify="flex-start"
        flexWrap="wrap"
        px={{ base: "2", md: "0" }}
      >
        <Button
          bg="moveon.primary"
          color="white"
          onClick={() => {
            setInterimState("add_origin", { isOpen: true });
          }}
        >
          <GenericIcon icon="add" />
          {PROFILE_SHAPING_LABELS.addSourceMaterial}
        </Button>
      </HStack>
    </VStack>
  );
}
